import { useAppSelector } from "@app/hooks"
import { selectLatestPublishedCoursesByIds } from "@features/coursesMenu/coursesSelectors"
import {
  CourseDescriptorDto,
  TermDto,
  TrackDto,
} from "@masterschool/course-builder-api"
import { Stack, Tooltip, Typography } from "@mui/material"
import AppIcon from "@utils/appIcon"
import appIcons from "@utils/appIcons"
import { durationToFormattedString } from "@utils/durationToFormattedString"

export const LiveSessionHours = (props: { hours: string }) => {
  return (
    <Tooltip title="Live session hours">
      <Stack direction="row" gap={1} alignItems="center">
        <AppIcon
          icon={appIcons.playCircle}
          props={{ sx: { width: "16px", height: "16px" } }}
        />
        <Typography variant="body3" color="textSecondary">
          {`${props.hours}`}
        </Typography>
      </Stack>
    </Tooltip>
  )
}

export const SelfLearningHours = (props: { hours: string }) => {
  return (
    <Tooltip title="Self-learning hours">
      <Stack direction="row" gap={1} alignItems="center">
        <AppIcon
          icon={appIcons.bookOpen01}
          props={{ sx: { width: "16px", height: "16px" } }}
        />
        <Typography variant="body3" color="textSecondary">
          {`${props.hours}`}
        </Typography>
      </Stack>
    </Tooltip>
  )
}

export const useGetTrackHours = (track: TrackDto) => {
  const courseDescriptorsIds = track.terms.flatMap((term) =>
    term.courseDescriptors.map((cd) => cd.courseId),
  )
  const courseDescriptors = useAppSelector((state) =>
    selectLatestPublishedCoursesByIds(state, courseDescriptorsIds),
  )
  return sumCoursesHours(courseDescriptors)
}

export const useGetTermHours = (term: TermDto) => {
  const courseDescriptors = useAppSelector((state) =>
    selectLatestPublishedCoursesByIds(
      state,
      term.courseDescriptors.map((cd) => cd.courseId),
    ),
  )
  return sumCoursesHours(courseDescriptors)
}

export function sumCoursesHours(courseDescriptors: CourseDescriptorDto[]) {
  const liveEventsDuration = courseDescriptors.reduce(
    (acc, cd) => acc + cd.liveEventsDuration,
    0,
  )
  const elementsDuration = courseDescriptors.reduce(
    (acc, cd) => acc + cd.elementsDuration,
    0,
  )
  return {
    liveSessionHours: durationToFormattedString(liveEventsDuration),
    selfLearningHours: durationToFormattedString(elementsDuration),
  }
}
